import i18n from 'modules/core/lib/i18n'

import documents_thumb from 'modules/onboarding/lib/assets/first_steps/document-management-thumb.jpg'
import engagement_thumb from 'modules/onboarding/lib/assets/first_steps/engagement-thumb.jpg'
import signature_thumb from 'modules/onboarding/lib/assets/first_steps/esignatures-thumb.jpg'
import expenses_thumb from 'modules/onboarding/lib/assets/first_steps/expenses-thumb.jpg'
import payroll_thumb from 'modules/onboarding/lib/assets/first_steps/payroll-thumb.jpg'
import performance_thumb from 'modules/onboarding/lib/assets/first_steps/performance-thumb.jpg'
import recruitment_thumb from 'modules/onboarding/lib/assets/first_steps/recruitment-thumb.jpg'
import shift_management_thumb from 'modules/onboarding/lib/assets/first_steps/shift-management-thumb.jpg'
import time_off_thumb from 'modules/onboarding/lib/assets/first_steps/time-off-thumb.jpg'
import time_tracking_thumb from 'modules/onboarding/lib/assets/first_steps/time-tracking-thumb.jpg'

import { FirstStepVideo, FirstStepVideoOption } from './types'

export const getFirstStepVideo = (
  key: string,
  value: string,
  locale: string
): FirstStepVideo | undefined => {
  const firstStepsVideos: FirstStepVideoOption[] = [
    {
      section: 'time_tracking',
      appsSection: 'time_tracking',
      location: '/attendance/time-tracking/',
      thumb: time_tracking_thumb,
      title: i18n.t('onboarding.first_steps.modal.time_tracking.title'),
      subtitle: i18n.t('onboarding.first_steps.modal.time_tracking.subtitle'),
      video_id: '2c5zek4jcz',
      locales: [
        { locale: 'fr', video_id: 'nyhhrwnrwi' },
        { locale: 'es-mx', video_id: '6k74wwtfjm' },
        { locale: 'de', video_id: 'yf0vjzjc2m' },
        { locale: 'pt', video_id: 'tv9sfygc51' },
        { locale: 'pt-br', video_id: '0yn516i9z9' },
        { locale: 'es', video_id: 'p4fyoof9ys' },
      ],
    },
    {
      section: 'time_off',
      appsSection: 'time_off',
      location: '/time-off',
      thumb: time_off_thumb,
      title: i18n.t('onboarding.first_steps.modal.time_off.title'),
      subtitle: i18n.t('onboarding.first_steps.modal.time_off.subtitle'),
      video_id: 'atsw57vf9v',
      locales: [
        { locale: 'fr', video_id: 'ezcts21p4z' },
        { locale: 'es-mx', video_id: '6ntfs95dny' },
        { locale: 'de', video_id: 'pg59i1k4ze' },
        { locale: 'pt', video_id: 'w9ys4893ze' },
        { locale: 'pt-br', video_id: 'e98v4sf4sk' },
        { locale: 'es', video_id: '2mishc48ko' },
      ],
    },
    {
      section: 'shift_management',
      appsSection: 'shift_management',
      location: '/shifts/',
      thumb: shift_management_thumb,
      title: i18n.t('onboarding.first_steps.modal.shift_management.title'),
      subtitle: i18n.t('onboarding.first_steps.modal.shift_management.subtitle'),
      video_id: 'ao9v6zt1md',
      locales: [
        { locale: 'fr', video_id: '0vnoonlhu6' },
        { locale: 'es-mx', video_id: 'z7hu821me2' },
        { locale: 'de', video_id: 'wttaj6pzde' },
        { locale: 'pt', video_id: '8t6w4pt843' },
        { locale: 'pt-br', video_id: 'u9zzbld4r8' },
        { locale: 'es', video_id: 'oda2e0ljaa' },
      ],
    },
    {
      section: 'recruitment',
      appsSection: 'ats',
      location: '/recruitment/',
      thumb: recruitment_thumb,
      title: i18n.t('onboarding.first_steps.modal.recruitment.title'),
      subtitle: i18n.t('onboarding.first_steps.modal.recruitment.subtitle'),
      video_id: 'sm7831udl5',
      locales: [
        { locale: 'fr', video_id: 'cr3s2rq1xc' },
        { locale: 'es-mx', video_id: 'xpxu136zd8' },
        { locale: 'de', video_id: '9mq2hn1g67' },
        { locale: 'pt', video_id: 'em6kb0cuu3' },
        { locale: 'pt-br', video_id: 'gcfcoz8n2a' },
        { locale: 'es', video_id: 'lus3z5aeg9' },
      ],
    },
    {
      section: 'performance',
      appsSection: 'performance_v2',
      thumb: performance_thumb,
      title: i18n.t('onboarding.first_steps.modal.performance.title'),
      subtitle: i18n.t('onboarding.first_steps.modal.performance.subtitle'),
      video_id: '03bzobyfv3',
      locales: [
        { locale: 'fr', video_id: 'ekkyhpp41c' },
        { locale: 'es-mx', video_id: 'rdy1d8ggmo' },
        { locale: 'de', video_id: 'uvy4t9qzx0' },
        { locale: 'pt', video_id: '903aj2wsq2' },
        { locale: 'pt-br', video_id: 'jssajfmzrh' },
        { locale: 'es', video_id: 'wmxa30sb48' },
      ],
    },
    {
      section: 'documents',
      location: '/files/',
      thumb: documents_thumb,
      title: i18n.t('onboarding.first_steps.modal.documents.title'),
      subtitle: i18n.t('onboarding.first_steps.modal.documents.subtitle'),
      video_id: 'ckpu733ugg',
      locales: [
        { locale: 'fr', video_id: 'h83b80r0tz' },
        { locale: 'es-mx', video_id: 'xfkfsktvq0' },
        { locale: 'de', video_id: '7tq7x2wrhc' },
        { locale: 'pt', video_id: '1cddi45f6t' },
        { locale: 'pt-br', video_id: '47fnhe4uy7' },
        { locale: 'es', video_id: 'btypkay7y9' },
      ],
    },
    {
      section: 'signature',
      thumb: signature_thumb,
      title: i18n.t('onboarding.first_steps.modal.signature.title'),
      subtitle: i18n.t('onboarding.first_steps.modal.signature.subtitle'),
      video_id: 'z41267pnen',
      locales: [
        { locale: 'fr', video_id: 'lwnvp3wvo5' },
        { locale: 'es-mx', video_id: 'o9qc9kp21f' },
        { locale: 'de', video_id: 'k8rla49759' },
        { locale: 'pt', video_id: 't96zzb1znx' },
        { locale: 'pt-br', video_id: '6m0bpz3xyz' },
        { locale: 'es', video_id: 'b5xxx5xd03' },
      ],
    },
    {
      section: 'expenses',
      appsSection: 'expenses_v2',
      location: '/expenses/',
      thumb: expenses_thumb,
      title: i18n.t('onboarding.first_steps.modal.expenses.title'),
      subtitle: i18n.t('onboarding.first_steps.modal.expenses.subtitle'),
      video_id: 'yzkt7fjb1b',
      locales: [
        { locale: 'fr', video_id: '7cret8uyt1' },
        { locale: 'es-mx', video_id: '7uqi2428ww' },
        { locale: 'de', video_id: 'efdapae6xn' },
        { locale: 'pt', video_id: '1weppabpe7' },
        { locale: 'pt-br', video_id: '8so6ru4oz3' },
        { locale: 'es', video_id: 'pzspp3ddef' },
      ],
    },
    {
      section: 'engagement',
      location: '/engagement/',
      thumb: engagement_thumb,
      title: i18n.t('onboarding.first_steps.modal.engagement.title'),
      subtitle: i18n.t('onboarding.first_steps.modal.engagement.subtitle'),
      video_id: '8zawvpx2dn',
      locales: [
        { locale: 'fr', video_id: 'npekh0iv0k' },
        { locale: 'es-mx', video_id: 'co1w1msmjx' },
        { locale: 'de', video_id: 'vqbntyr3z8' },
        { locale: 'pt', video_id: 'p34d2zabu5' },
        { locale: 'pt-br', video_id: 'zp2bwnio5a' },
        { locale: 'es', video_id: '7lezurwwjj' },
      ],
    },
    {
      section: 'payroll',
      appsSection: 'payroll_bundle',
      location: '/payroll-management/',
      thumb: payroll_thumb,
      title: i18n.t('onboarding.first_steps.modal.payroll.title'),
      subtitle: i18n.t('onboarding.first_steps.modal.payroll.subtitle'),
      video_id: 'c0m7eig65g',
      locales: [
        { locale: 'fr', video_id: '55b6fmcdh3' },
        { locale: 'es-mx', video_id: '2ueuvmrtlv' },
        { locale: 'de', video_id: 'w1k59e865l' },
        { locale: 'pt', video_id: '2zkkj70c7k' },
        { locale: 'pt-br', video_id: '39lkqnn9j8' },
        { locale: 'es', video_id: '79yw8p531q' },
      ],
    },
  ]

  // To remove after we have better french videos :)
  if (locale === 'fr') {
    return undefined
  }

  const video = firstStepsVideos.find((item: FirstStepVideoOption) => {
    if (key === 'location' && item.location) {
      return value.startsWith(item.location)
    }
    if (key === 'appsSection' && item.appsSection) {
      return item.appsSection === value
    }
    return null
  })
  if (video) {
    const { section, thumb, title, subtitle } = video
    const localeVideo = video.locales.find((item) => item.locale === locale)
    const video_id = localeVideo ? localeVideo.video_id : video.video_id
    return { section, thumb, title, subtitle, video_id }
  } else {
    return undefined
  }
}
